@import '../component/_useragent.js'
document.createElement("picture");
svg4everybody();

$(function() {
	// side navi toggle ==================================
	$('.js-toogle--btn').on('click', function(event) {
		if ($(this).hasClass('is-active')) {
			$('.js-toogle--content').slideUp(400);
			$('.js-toogle--content').removeClass('is-active');
			$('.js-toogle--btn').removeClass('is-active');
		} else {
			$('.js-toogle--btn').removeClass('is-active');
			$('.js-toogle--content').slideUp(400);
			$('.js-toogle--content').removeClass('is-active');
			$(this).addClass('is-active');
			$(this).next('.js-toogle--content').slideDown(400);
			$(this).next('.js-toogle--content').addClass('is-active')
		}
	});

	// $('#js-float--bnr').on('click', function(event) {
	// 	$(this).addClass('is-hide');
	// });


	var floatBnr = $('#js-float--bnr');
	// floatBnr.hide();
	floatBnr.addClass('is-disable');
	//スクロールが100に達したらボタン表示
	$(window).scroll(function() {
		if ($(this).scrollTop() > 1500) {
			floatBnr.removeClass('is-disable');

		} else {
			floatBnr.addClass('is-disable');
		}
	});



	if ($.cookie('bnrRead') != 'on') {
		$('#js-float--bnr').removeClass('is-hide');
	}
	$('#js-float--bnr').on('click', function(event) {
		$('#js-float--bnr').addClass('is-hide');
		$.cookie('bnrRead', 'on', {
			expires: 1,
			path: '/'
		});
	});
	if ("?del" == location.search) {
		$.removeCookie("bnrRead");
	}




	// $(window).on('scroll', function() {
	// 	var doch = $(document).innerHeight(); //ページ全体の高さ
	// 	var winh = $(window).innerHeight(); //ウィンドウの高さ
	// 	var footer = $('#js-footer').offset().top;
	// 	var footerCalc = winh - footer;
	// 	console.log(footerCalc);
	//
	// 	var bottom = doch - winh - footerCalc; //ページ全体の高さ - ウィンドウの高さ = ページの最下部位置
	// 	if (bottom <= $(window).scrollTop()) {
	// 		//一番下までスクロールした時に実行
	// 		// console.log("最底辺！");
	// 		floatBnr.removeClass('is-disable');
	//
	// 	}
	// });


	// var adOffset, adSize;
	//
	// $(window).on('load resize', function() {
	// 	adOffset = $('#js-footer').offset().top;
	// 	// winH = $(window).height();
	// 	winH = $('body').height();
	// 	floatBnrFlag = $('#js-float--bnr--flag').offset().top;
	// 	floatBnrFlag = floatBnrFlag - 2000;
	// 	console.log(floatBnrFlag);
	// });
	// $(function() {
	// 	var floatBnr = $('#js-float--bnr');
	// 	// var message = $('#mes');
	// 	// floatBnr.hide();
	// 	//スクロール量がmesPointに達していなければmessageを非表示、達して入れば表示します
	// 	$(window).scroll(function() {
	// 		if ($(this).scrollTop() > floatBnrFlag) {
	// 			// floatBnr.fadeIn();
	// 			floatBnr.removeClass('is-disable');
	//
	// 		} else {
	// 			// floatBnr.fadeOut();
	// 			floatBnr.addClass('is-disable');
	//
	// 		}
	// 	});
	// });



	//
	//
	// $(window).on('load resize',function(){
	//         btnOffset = $('.box.btn-show').offset().top;
	//         winH = $(window).height();
	//     });
	//     $(function() {
	//         var fixedbtn = $('.fixed-btn__area');
	//         fixedbtn.hide();
	//         $(window).scroll(function () {
	//             if ($(this).scrollTop() > btnOffset - winH) {
	//                 fixedbtn.fadeIn();
	//             } else {
	//                 fixedbtn.fadeOut();
	//             }
	//         });
	//     });


	// var timer = false;
	// //リサイズ時ファンクション再実行
	// $(window).on('resize', function() {
	// 	if (timer !== false) {
	// 		clearTimeout(timer);
	// 	}
	// 	timer = setTimeout(function() {
	// 		// console.log('resized');
	// 		targetCu();
	// 	}, 200);
	// });

	// console.log('cookie');
	//cookie privacy注意喚起
	var cookietext = '<p>当サイトでは利便性の改善や閲覧の追跡の為、Cookieを使用しています。サイトの閲覧を続行した場合、Cookieの使用に同意したことになります。詳しくは<a href="/cookie/">クッキーポリシー</a> をご参照下さい。</p>';

	var addhtml = '<div class="js-cookiemodal"><div class="c-inner"><a href="javascript:;" class="c-close js-cookiemodal-close"><svg class="icon icon-close02"><use xlink:href="/wordpress/wp-content/themes/3rock-renew/img/sprite.svg#icon_close02"></use></svg></a>' + cookietext + '</div></div>';

	var uscookietext = '<p>This website intends to use cookies to improve the site and your experience. By continuing to browse the site you are agreeing to accept our use of cookies. If you require further information and/or do not wish to have cookies placed when using the site, visit <a href="/en/cookie/">About Cookies page.</a></p>';

	var usaddhtml = '<div class="js-cookiemodal"><div class="c-inner"><a href="javascript:;" class="c-close js-cookiemodal-close"><svg class="icon icon-close02"><use xlink:href="/wordpress/wp-content/themes/3rock-renew/img/sprite.svg#icon_close02"></use></svg></a>' + uscookietext + '</div></div>';

	// $('body .l-footer').after(addhtml);
	//


	if ($.cookie("access") == undefined) {
		$.cookie("access", "onece");
		// $('body.ja footer').after(addhtml);
		// $('body.en-US footer').after(usaddhtml);
		$('body .l-footer').after(addhtml);
	} else {}

	$('.js-cookiemodal-close').on('click', function() {
		$('.js-cookiemodal').remove();
	});
	if ("?del" == location.search) {
		$.removeCookie("access");
	}



	@import '../component/_waypoint.js'

	@import '../component/_navi.js'
	@import '../component/_smoothscroll.js'


	$('.menu-btn-more').on('click', function(event) {
		$(this).next('.menu-list').slideToggle(400);
	});

});

$(window).on('load', function() {
	$('html').addClass('is-loaded');
	objectFitImages();

});
